<!--实时状态-->
<template>
<div class="rts commonborder flex_column">
  <div id="rts_pie1" class="echarts"></div>
  <div class="title">最近事件</div>
  <div class="sjbox">
    <div class="box" v-for="(item,index) in sjData" :key="index">
      <div class="title"><span>{{item.name}}</span><span>{{item.time}}</span></div>
      <div>事件类型：{{item.type}}</div>
      <div>所在位置{{item.address}}</div>
    </div>
  </div>
</div>

</template>

<script>
let echarts = require("echarts/lib/echarts");
export default {
  props: ["deviceId"],
  data() {
    return {
      rtsData: [
          {value: 15, name: '电力采集点'},
          {value: 29, name: '燃油采集点'},
          {value: 15, name: '燃气采集点'},
          {value: 18, name: '空气采集点'},
          {value: 20, name: '水力采集点'},
          {value: 20, name: '环境采集点'}
      ],
      sjData:[
        {id:0,name: '一车间2#空压机', type: '启动',time:'01-01 12:24:47',address:'全区/一车间/1号生产线'},
        {id:1,name: '一车间2#空压机', type: '启动',time:'01-01 12:24:47',address:'全区/一车间/1号生产线'},
        {id:2,name: '一车间2#空压机', type: '启动',time:'01-01 12:24:47',address:'全区/一车间/1号生产线'},
      ],
    };
  },
  methods: {
    rts_pie1(){
      let rts_pie1 = echarts.init( document.getElementById('rts_pie1') );
      rts_pie1.setOption({
          color:['#00ccff','#24ffb1','#fc5976','#ae74f3','#f4af1b','#fff45c'],
          tooltip: {
              trigger: 'item',textStyle:{fontSize: this.$echartsFontSize},
          },
          legend: {
              left:'center',bottom:'15px', 
              textStyle: {
                  color: "#ccd0f2",fontSize:this.$echartsFontSize-4, lineHeight:20, padding:[0,30,0,0],
              },
              itemWidth: 13,itemHeight: 13,
          },
          title: [{
              text: '监测点',
              x: 'center',
              top: '38%',
              textStyle: {
                  color: '#ccd0f2',
                  fontSize:this.$echartsFontSize-2,
                  fontWeight: '100',
              }
          }, {
              text: '29',
              x: 'center',
              top: '30%',
              textStyle: {
                  fontSize:this.$echartsFontSize+8,
                  color: '#fff',
                  fontWeight: '600',
              },
          }],
          series: [
              {
                  name: '采集点',
                  type: 'pie',
                  radius: ['27%', '38%'],
                  center:['50%','38%'],
                  avoidLabelOverlap: true,
                  itemStyle: {
                      borderRadius: 4,
                      borderColor: '#081693',
                      borderWidth: 2
                  },
                  label: {
                      show: true,color:'#ccd0f2',fontSize:this.$echartsFontSize-3,
                      formatter: '{b}\n{num|{c}}', lineHeight:this.$echartsFontSize+4,
                      rich: {
                          num: {
                              color: '#fff',fontSize:this.$echartsFontSize
                          }
                      }
                  },
                  data:this.rtsData
              }
          ] 
      })
    },
  },
  mounted() {
    this.$nextTick(()=>{
      this.rts_pie1();
    })
  },
};
</script>

<style lang="less" scoped>
.rts{ background: rgba(3,15,97,.2); border: #555e86 dashed 1px; border-radius: 6px; width: 13rem; position: absolute; right: 16px; height: 96%; top: 2%;
  .echarts{ height: 12rem;}
  .title{ color: #00ccff; margin: 8px 15px; font-size: .6rem; font-weight: bold;}
  .sjbox{ display: flex; flex-direction: column; flex: 1; overflow:hidden; padding-bottom: 8px;
    .box{ flex: 1; border:#00ccff dashed 1px; border-radius: 5px; margin: 8px 15px; font-size: .5rem; padding:8px 15px; display: flex; flex-direction: column; justify-content: center;
      &>div{ flex: 1;}
      .title{ color: #fff; display: flex; flex-direction: row; margin: 8px 0; font-weight: normal;
        span{ text-overflow:ellipsis; white-space: nowrap; overflow: hidden;}
        span:nth-child(1){ flex:1; font-size: .55rem;}
        span:nth-child(2){ width:4rem; text-align: right; opacity: .8; font-size: .5rem;}
      }
    }
  }
}
</style>